/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import * as React from "react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";
import { ThemeProvider } from "./src/context/theme";

// Styling for the preview modals.
import "gatsby-plugin-prismic-previews/dist/styles.css";

// Adds a shared React Context for Prismic preview sessions.
export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <PrismicPreviewProvider>{element}</PrismicPreviewProvider>
  </ThemeProvider>
);
